<div class="surface-card border-1 surface-border border-round p-3">
    <div class="flex align-items-center justify-content-between gap-3 mb-3">
        <div>
            <h3 class="m-0 text-lg font-semibold">Workflow</h3>
            <span class="text-sm text-500">{{ resourceKey }} #{{ resourceId }}</span>
        </div>
        @if (instance) {
            <p-tag [value]="instance.currentStatusCode" severity="info"></p-tag>
        }
    </div>

    <p-progressBar *ngIf="isLoading" mode="indeterminate" styleClass="mb-3"></p-progressBar>

    @if (errorMessage) {
        <p-message severity="warn" [text]="errorMessage" styleClass="mb-3"></p-message>
    }

    @if (!instance) {
        <button pButton type="button" icon="pi pi-play" label="Start Workflow" (click)="startWorkflow()" [disabled]="isLoading"></button>
    } @else {
        <div class="flex flex-column gap-3">
            <textarea pTextarea [(ngModel)]="comment" rows="3" placeholder="Action comment" class="w-full"></textarea>

            <div class="flex flex-wrap gap-2">
                @for (action of actions; track action.transitionId) {
                    <button
                        pButton
                        type="button"
                        icon="pi pi-send"
                        [label]="action.label"
                        (click)="perform(action)"
                        [disabled]="isLoading || (action.requiresComment && !comment.trim())">
                    </button>
                }
                @if (!actions.length) {
                    <span class="text-sm text-500">No actions are currently available.</span>
                }
            </div>

            <p-timeline [value]="history" align="left" styleClass="mt-2">
                <ng-template pTemplate="content" let-item>
                    <div class="flex flex-column gap-1">
                        <span class="font-medium">{{ item.actionCode }} -> {{ item.toStatusCode }}</span>
                        <span class="text-sm text-500">{{ item.performedAt | date:'medium' }}</span>
                        @if (item.comment) {
                            <span class="text-sm">{{ item.comment }}</span>
                        }
                    </div>
                </ng-template>
            </p-timeline>
        </div>
    }
</div>
